import React from "react"
import Footer from "../components/footer"
import Navbar from "../components/nav"

function C2paAiDetectorTerms() {
  return (
    <>
      <header className="header-area">
        <div className="navbar-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <Navbar />
              </div>
            </div>
          </div>
        </div>
      </header>

      <div id="home">
        <div className="container mt-125 mb-50">
          <div className="card-body shadow">
            <h4>Terms & Conditions - C2PA AI Detector</h4>
            <br />
            <ul>
              <li>THE DEVELOPER = MWX Apps</li>
              <li>THE APP = C2PA AI Detector</li>
              <li>PACKAGE = c2pa.aidetector.mwxapps</li>
            </ul>
            <br />
            <p>
              By downloading or using THE APP, these terms will automatically apply
              to you – you should make sure therefore that you read them carefully
              before using THE APP. You're not allowed to copy, or modify THE APP,
              any part of THE APP, or our trademarks in any way. You're not allowed
              to attempt to extract the source code of THE APP, and you also
              shouldn't try to translate THE APP into other languages, or make
              derivative versions. THE APP itself, and all the trade marks,
              copyright, database rights and other intellectual property rights
              related to it, still belong to THE DEVELOPER.
            </p>
            <p>
              THE DEVELOPER is committed to ensuring that THE APP is as useful and
              efficient as possible. For that reason, we reserve the right to make
              changes to THE APP or to charge for its services, at any time and for
              any reason. We will never charge you for THE APP or its services
              without making it very clear to you exactly what you're paying for.
            </p>

            <br />
            <strong>How the App Works - On-Device Processing</strong>
            <p>
              THE APP analyzes images <strong>directly on your device</strong>.
              C2PA Content Credentials, EXIF metadata, provenance information, issuer
              data and edit history are read and parsed locally. Your images are
              never uploaded to our servers. This means no internet connection is
              required for core functionality and your photos remain private.
            </p>
            <p>
              When you select an image from your gallery or camera, it is processed
              in your device's memory. Analysis results and thumbnail previews are
              stored locally in the app's private storage and can be deleted at any
              time via Clear History.
            </p>

            <br />
            <strong>Device Security</strong>
            <p>
              It's your responsibility to keep your phone and access to THE APP
              secure. We therefore recommend that you do not jailbreak or root your
              phone, which is the process of removing software restrictions and
              limitations imposed by the official operating system of your device.
              It could make your phone vulnerable to malware/viruses/malicious
              programs, compromise your phone's security features and it could mean
              that THE APP won't work properly or at all.
            </p>

            <br />
            <strong>C2PA & AI Detection Accuracy Disclaimer</strong>
            <p>
              THE APP reads C2PA Content Credentials and technical metadata embedded
              in images. C2PA data is only present if the image creator or camera
              app added it. Absence of C2PA data does NOT prove an image is AI-generated
              or fake. Conversely, presence of C2PA data does not guarantee absolute
              authenticity – credentials can be stripped, edited or misinterpreted.
            </p>
            <p>
              While we strive for high accuracy, THE DEVELOPER cannot guarantee 100%
              accuracy in detecting AI-generated content, issuer verification or
              edit history. Results should be used as a guide and not as sole or
              definitive proof for legal, journalistic or forensic decisions. Always
              cross-check with other sources. THE DEVELOPER accepts no liability for
              any decisions made based on analysis results.
            </p>

            <br />
            <strong>Permissions</strong>
            <p>
              THE APP requests Camera (optional, to capture photos) and Storage/Media
              (to access images you select). Both are used only when you explicitly
              choose an image. Internet permission, if present, is not used for
              uploading your images – analysis is offline.
            </p>

            <br />
            <strong>Intellectual Property</strong>
            <p>
              THE APP and its original content, features and functionality are and
              will remain the exclusive property of THE DEVELOPER and its licensors.
              C2PA, Content Credentials logos and related marks belong to their
              respective owners. You may not use our trademarks without prior written
              consent.
            </p>

            <br />
            <strong>Prohibited Uses</strong>
            <p>You agree not to use THE APP:</p>
            <ul>
              <li>In any way that violates any applicable law or regulation</li>
              <li>To harass, abuse or harm another person</li>
              <li>To attempt to reverse-engineer, decompile or extract the source code</li>
              <li>To use THE APP for illegal forgery of C2PA credentials or metadata</li>
              <li>To upload or transmit viruses, malware or harmful code</li>
              <li>To infringe upon the rights of others or impersonate THE DEVELOPER</li>
            </ul>

            <br />
            <strong>Third-Party Services</strong>
            <p>
              THE APP does NOT use Google Analytics, Firebase Analytics, Facebook SDK,
              advertising networks or third-party tracking. The APP is distributed via
              Google Play Store, whose use is governed by Google's Terms. We rely on
              open-source libraries (e.g., C2PA parsing, EXIF tools) that run locally
              and do not transmit data.
            </p>

            <br />
            <strong>Limitation of Liability</strong>
            <p>
              With respect to THE DEVELOPER's responsibility for your use of THE APP,
              when you're using THE APP, it's important to bear in mind that although
              we endeavour to ensure that it is updated and correct at all times,
              THE DEVELOPER accepts no liability for any loss, direct or indirect,
              you experience as a result of relying wholly on this functionality of
              THE APP. THE APP IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT
              WARRANTIES OF ANY KIND.
            </p>

            <br />
            <strong>Updates and Termination</strong>
            <p>
              At some point, we may wish to update THE APP. THE APP is currently
              available on Android – the requirements for system (and for any
              additional systems we decide to extend the availability of THE APP to)
              may change, and you'll need to download the updates if you want to keep
              using THE APP. THE DEVELOPER does not promise that it will always
              update THE APP so that it is relevant to you and/or works with the
              Android version that you have installed on your device. However, you
              promise to always accept updates to THE APP when offered to you. We may
              also wish to stop providing THE APP, and may terminate use of it at any
              time without giving notice of termination to you. Unless we tell you
              otherwise, upon any termination, (a) the rights and licenses granted to
              you in these terms will end; (b) you must stop using THE APP, and (if
              needed) delete it from your device.
            </p>

            <br />
            <strong>Governing Law</strong>
            <p>
              These Terms shall be governed and construed in accordance with the laws
              of Turkey, without regard to its conflict of law provisions. Any disputes
              shall be submitted to the competent courts of Turkey.
            </p>

            <br />
            <strong id="changes-to-these-terms-and-conditions">
              <a
                aria-hidden="true"
                href="#changes-to-these-terms-and-conditions"
                tabindex="-1"
              >
                <span class="icon icon-link"></span>
              </a>
              Changes to These Terms and Conditions
            </strong>
            <p>
              We may update our Terms and Conditions from time to time. Thus, you are
              advised to review this page periodically for any changes. We will
              notify you of any changes by updating the "Last Updated" date. These changes
              are effective immediately after they are posted on this page.
              This policy is effective as of August 18, 2026.
            </p>

            <br />
            <strong id="contact-us">
              <a aria-hidden="true" href="#contact-us" tabindex="-1">
                <span class="icon icon-link"></span>
              </a>
              Contact Us
            </strong>
            <p>
              If you have any questions or suggestions about these Terms and
              Conditions, do not hesitate to contact us at: mwxapps@gmail.com or
              web-developer@outlook.com
            </p>
            <p className="mt-2"><strong>Developer:</strong> MWX Apps</p>
            <p><strong>App:</strong> C2PA AI Detector (c2pa.aidetector.mwxapps)</p>
          </div>
          <Footer />
        </div>
      </div>
    </>
  )
}

export default C2paAiDetectorTerms
